import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router'
import { Modal, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab'

// Styles
import '../../assets/styles.css'

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function VerifyUserComponent() {

    const history = useHistory()

    // Loading
    const [isLoadingModalOpen, setLoaginModalOpen] = useState(false)

    // Snackbar
    const [alertSeverity, setAlertSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertDuration, setAlertDuration] = useState(3000)
    const [alertOpen, setAlertOpen] = useState(false)

    function showAlert(severity, message, duration) {
        setAlertSeverity(severity)
        setAlertMessage(message)
        setAlertDuration(duration)
        setAlertOpen(true)
    }

    function checkedLogedIn() {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
                history.replace('/login')
            } else {
                getUnverifiedUsers()
            }
        })
    }

    function getUnverifiedUsers() {

        let usersList = []

        setLoaginModalOpen(true)

        firebase.firestore().collection('users').get().then((query) => {

            query.forEach((user) => {
                const data = user.data()

                if(data.verified === 'no') {
                    usersList.push(data)
                }
            })


            let html = ''

            if(usersList.length > 0) {
                usersList.forEach((element) => {
    
                    html += '<div>'+
                    '<h3>' + element.establishmentName + '</h3>'+
                    '<p>- Dirección: <b>' + element.address + '</b></p>'+
                    '<p>- Ciudad: <b>' + element.city + '</b></p>'+
                    '<p>- Responsable: <b>' + element.responsable + '</b></p>'+
                    '<p>- Email: <b>' + element.email + '</b></p>'+
                    '<p>- Teléfono: <b>' + element.phoneN + '</b></p>'+
                    '<p>- Nº RUC: <b>' + element.rucN + '</b></p>'+
                    '<button type="button" id="' + element.appUserID + '-verify" class="btn btn-secondary" style="width: 100%;" > VERIFICAR </button>'+
                    '<div class="blue-divider" ></div>'+
                    '</div>'
    
                })
    
                document.getElementById('listBody').innerHTML = html;
    
                setLoaginModalOpen(false)
    
                usersList.forEach((element) => {
                    document.getElementById(element.appUserID + '-verify').addEventListener('click', () => {
                        setLoaginModalOpen(true)
    
                        firebase.firestore().collection('users').doc(element.appUserID.toString()).update({verified: 'yes'}).then(() => {
                            setLoaginModalOpen(false)
                            showAlert('success', 'Establecimiento verificado con éxito!', 3000)
                            getUnverifiedUsers()
                        }).catch((error) => {
                            setLoaginModalOpen(false)
                            console.error(error)
                            showAlert('error', 'Ha ocurrido un error al verificar el establecimiento, inténtalo más tarde.', 3000)
                        })
                    })
                })
            } else {
                document.getElementById('listBody').innerHTML = html;
                setLoaginModalOpen(false)
                showAlert('warning', 'No hay ningún establecimiento pendiente de verificación.', 3000)
            }

        }).catch((error) => {
            console.error(error)
            showAlert('error', 'Ha ocurrido un error al recuperar los establecimientos pendientes de verificación, inténtalos más tarde.', 3000)
        })
    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div>
            <br></br>
            <div className="container" >
                <div className="row" >
                    <div className="col text-center" >
                        <h1 style={{ color: '#FB3D44'}} >
                            VERIFICACIÓN DE USUARIOS
                        </h1>
                    </div>
                </div>
                <div className='row blue-divider'></div>
                <br></br>
                <div className='row' >
                    <div className='col-1' ></div>
                    <div className='col-10' >
                        <ul className='list-group' id='listBody' >
                        </ul>
                    </div>
                    <div className='col-1' ></div>
                </div>
            </div>
            <br></br>
            {/**
             * 
             * MODAL ZONE
             * 
             */}
            <Modal
            disableEnforceFocus
            open={isLoadingModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
                </div>
            </Modal>
            {/**
             * 
             * SNACKBAR
             * 
             */}
            <Snackbar
            open={alertOpen}
            autoHideDuration={alertDuration}
            onClose={() => {
                setAlertOpen(false)
            }} >
                <Alert 
                variant='filled'
                severity={alertSeverity} >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/verifyUser/VerifyUserComponent.js